import { Injectable } from "@angular/core";

import { environment } from "@environments/environment";

export type MicroserviceType =
  | "orderEntry"
  | "configServ"
  | "vendorManagement"
  | "elsaWorkflow"
  | "auth"
  | "clientManagement"
  | "loanManagement"
  | "orderWorkflow"
  | "userManagement";

@Injectable({
  providedIn: "root",
})
export class AppConfigService {
  public readonly apiUrls = environment.apiUrls;
  public readonly production = environment.production;

  public getApiUrl(microservice: MicroserviceType): string {
    return this.apiUrls[microservice];
  }
}
